export default __webpack_public_path__ + "static/media/23 Track 23.34995066.mp3";